import Image from '@/shared/components/shared/Image';
import { formatPhoneHref } from '@/shared/lib/utils/strings/index';
import { TeamPerson } from '../../../../entities/teamPerson';
import Typografed from '../Typografed';

type Props = React.HTMLAttributes<HTMLElement> & {
    tag?: keyof JSX.IntrinsicElements;
    teamPerson: TeamPerson;
};

const TeamItem = ({ tag = 'div', teamPerson }: Props) => {
    if (!teamPerson) {
        return null;
    }

    const Component = tag;

    return (
        <Component className="team__item">
            <div className="team__item-pic">
                {teamPerson.img?.src && (
                    <Image
                        className="news-slider-img"
                        src={teamPerson.img.src}
                        alt={teamPerson.img.alt || ''}
                        title={teamPerson.img.title || ''}
                        width={teamPerson.img.width}
                        height={teamPerson.img.height}
                        sizes="(max-width: 768px) 100vw, 20vw"
                    />
                )}
            </div>

            <div className="team__item-info">
                <div className="team__item-info__block">
                    <div className="team__item-info__block-top">
                        <div className="team__item-name text-m">{teamPerson.name}</div>
                        {teamPerson.position && (
                            <div className="team__item-position text-s">
                                <Typografed>{teamPerson.position}</Typografed>
                            </div>
                        )}
                    </div>
                </div>

                <div className="team__item-info__block">
                    {teamPerson.phone && (
                        <div className="team__item-number text-s">
                            <div className="team__item-title">Телефон:</div>
                            <a className="team__item-phone" href={`tel:${formatPhoneHref(teamPerson.phone)}`}>
                                {teamPerson.phone}
                            </a>
                        </div>
                    )}
                    {teamPerson.email && (
                        <div className="team__item-email-wrapper text-s">
                            <div className="team__item-title ">E-mail:</div>
                            <a href={`mailto:${teamPerson.email}`} className="team__item-email">
                                {teamPerson.email}
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </Component>
    );
};

export default TeamItem;
